// Download plumbing shared by the artifact renderers. Lives apart from the
// component file so react-refresh sees component-only modules.

export function downloadBlob(payload: string | Blob, filename: string, mime: string): void {
  const blob =
    typeof payload === "string" ? new Blob([payload], { type: mime }) : payload;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function safeFilename(title: string | undefined, fallback: string): string {
  return (title ?? fallback)
    .toLowerCase()
    .replace(/[^a-z0-9._-]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
